export const locale = {
  plaid: {
    en: 'US bank account',
    'zh-Hans': '美国银行账户',
    'zh-Hant': '美國銀行賬戶',
  },
  stripe: {
    en: 'Debit / Credit card',
    'zh-Hans': '借记卡/信用卡',
    'zh-Hant': '借記卡/信用卡',
  },
};
